import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import axiosApi from '../../../../api/daonAxios';
import {
    getIsBirthSix,
    getNuPatientNumberByHospital
} from '../../../../assets/js/comm';
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import CODE from '../../../../constants/code';
import URL, { DEV_MODE_AT } from '../../../../constants/url';
import style from './MyHospitalLink.module.css';
import AlertBox from '../../../../components/box/AlertBox';


const MyHospitalLink = () => {

    /*****************
     * 주요 변수 선언부
    ******************/


    const navigate = useNavigate();
    const location = useLocation();

    const { hsptlCd = [], hsptlNm = [] } = location.state || {};

    //console.log(" ===============> MyHospitalLink location.state : ", location.state);
    //console.log(" ===============> MyHospitalLink location.state.hsptlNm : ", hsptlNm );

    const user = JSON.parse(sessionStorage.getItem("loginUser"));
    //console.log( " ==========> HospitalLink session user : ", user );
    // 동의 내용 보기
    const [open, setOpen] = useState(false);

    // 진행 스텝
    const [step, setStep] = useState(1);

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [ hospitalList, setHospitalList ] = useState([]);
    // 사용자 병원맵
    const [ hospitalMap, setHospitalMap ] = useState([]);
    // 사용자 이름
    const userNmRef = useRef('');
    const [ userNm, setUserNm ] = useState('');
    // 주민번호 첫자리
    const firstPidRef = useRef('');
    // 주민번호 뒷자리
    const lastPidRef = useRef('');

    // 주민번호 view
    const [ lastPidView, setLastPidView ] = useState(false);
    // 주민번호 유효검사
    const [ firstPidRule, setFirstPidRule ] = useState({
        lengthAt: false,
        birthAt: false
    });
    const [ lastPidRule, setLastPidRule ] = useState(false);
    // 본인인증 유효검사 //가입정보와 일치해야함. //이름 + 생년월일 ( 강도 : 중 )
    const [ userCertRule, setUserCertRule ] = useState({
        nameCheck: ( user?.usrNm !== undefined ? true : false ),
        birthCheck: false,
        genderCheck: false
        }); // 개발까지는 꺼둘 필요성이 있음.. 꺼두면 계정에 타환자랑 연결 가능.

    // 동의 체크박스
    const [agreeCheck, setAgreeCheck] = useState(false);
    // 환자연동 체크박스
    const [ patientCheck, setPatientCheck ] = useState({});

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);

    //약관 상세 보기
    const [policeInfo, setPoliceInfo] = useState({
                title : '',
                children  : ''
        })
    const [policeList, setPoliceList] = useState([]);

    // AlertBox 팝업
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertText, setAlertText ] = useState("");

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };


    /*****************
     * 기능 함수 선언부
     ******************/

    useEffect(() => {
        setOpen(false);

        if(isInitialRender) {
            searchCmcHospitalList();
            isInitialRender.current = false;
        }

    }, []);

    function onDismiss() {
        setOpen(false);
    };

    const handleLastPidView = () => {
        setLastPidView(!lastPidView);
    };

    const handleOnBack = () => {
        navigate(URL.MY_HOSPITAL_CONNECTION, {
            replace: true,
            state: { refreshAt: false }
        });
    };

    /**
     * 기준정보 cmc 계열 병원 리스트 조회
     */
    const searchCmcHospitalList = () => {

        const requestCmcHospital = "/hsptl/retrieveCmcHospitalBaseList";

        const jToken = localStorage.getItem('jToken');

        const requestOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
        }

        axiosApi.post(requestCmcHospital, {}, requestOptions)
            .then( (res) => {
                const resData = res.data;
                if( resData.resultCode === CODE.RCV_SUCCESS ) {
                    const hospitalList = resData.result.hospitalList;
                    if( hospitalList.length > 0 ) {

                        const filteredHsptlList = hospitalList.filter(item => hsptlCd.includes(item.insttClCd));
                        setHospitalList(filteredHsptlList);
                        //setHospitalList(hospitalList);
                        //console.log( " ===============> searchCmcHospitalList : ", filteredHsptlList );
                    }
                } else {
                    setHospitalList([]);
                }
            })
            .catch( err => {
                console.log(" ==================> searchCmcHospitalList error : ", err );
            })
    };


    /**
     * 인풋박스 텍스트 온체인지 이벤트 처리
     * @param e
     */
    const handleOnChangeInput = (e) => {

        const inputName = e.target.name;
        //console.log( " ======> input event : ", e.target.name );
        if( inputName === "userNm" ) {
            const inputUserNm = userNmRef.current;
            if( inputUserNm ) {
                const nameCheck = inputUserNm.value === user?.usrNm  // 가입한 이름이 동일한지 ..
                setUserCertRule({ ...userCertRule, nameCheck: nameCheck });
            }
        }
        if( ["firstPid", "lastPid"].includes(inputName) ) {
            // 숫자 정규식 check
            const inputPid = inputName === 'firstPid' ? firstPidRef.current : lastPidRef.current;

            if(inputName === 'firstPid') {
                const lengthAt = inputPid.value.length === 6;
                const birthAt = getIsBirthSix(inputPid.value.trim());
                if( user?.brthdy !== undefined ) {
                    const birth = user.brthdy.length === 8 ? user.brthdy.substring(2, 8) : user.brthdy.length;
                    const birthCheck = birth === inputPid.value;
                    setUserCertRule( { ...userCertRule, birthCheck: birthCheck } );
                } else {
                    // 가입시 생년월일이 없는 경우는... 우선 통과시켜줌.  //추후 정확한 진단을 위해 막아야할수 있음.
                    setUserCertRule( { ...userCertRule, birthCheck: true } );
                }
                setFirstPidRule({ lengthAt, birthAt });
            } else {
                const lengthAt = inputPid.value.length === 7; // 자릿수
                if( user?.gendr !== undefined ) {
                    let genderCheck = false;
                    const genderChar = inputPid.value.substring(0, 1);
                    if( user.gendr === "1" ) {
                        genderCheck = ['1', '3', '5', '7'].includes(genderChar);
                    } else if ( user.gendr === "0" ) {
                        genderCheck = ['2', '4', '6', '8'].includes(genderChar);
                    }
                    setUserCertRule( { ...userCertRule, genderCheck: genderCheck });
                } else {
                    // 가입시 성별이 없는 경우는... 우선 통과시켜줌.  //추후 정확한 진단을 위해 막아야할수 있음.
                    setUserCertRule( { ...userCertRule, genderCheck: true } );
                }
                setLastPidRule(lengthAt);
            }
        }
    };


    /**
     * 체크박스 온체인지 이벤트
     * @param e
     */
    const handleOnChangeCheck = (e) => {

        const newVal = e.target.checked;
        const checkedId = e.target.id;
        if( checkedId === "require-chk2") {
            setAgreeCheck(newVal);
        }
        if( checkedId.indexOf("select") > -1) {
            // 기본이 이렇슴..
            //let checkedObj = { ...patientCheck, [checkedId]: newVal };
            let checkedObj = {};
            // 초기화 ...
            //let patientObj = [ ...hospitalMap ];
            //let patientItem = {};
            //const checkedIdx = checkedId.charAt(checkedId.length - 1);
            let idx = 1;
            hospitalMap.forEach( (item) => {
                /*
                if(idx === checkedIdx) {
                    patientItem = { ...item, hsptlSortOrdr: 1 };
                    patientObj.forEach( (item) => {

                    })
                }*/
                checkedObj = { ...checkedObj, ["select"+idx]: false };
                idx++;
            });
            checkedObj = { ...checkedObj, [checkedId]: newVal };

            setPatientCheck( checkedObj );
        }
    };



    const getClnicInfo = useCallback(async (userHospitalArr) => {

        const url = "/hsptl/saveHsptlConnectedInfo";
        const jToken = localStorage.getItem('jToken');

        //console.log("userHospitalArr : ", userHospitalArr)


        if(Array.isArray(userHospitalArr)){

            const reqParam = userHospitalArr?.map((item) => ({
                ...item,
                cnncHsptlCd: item.cnncHsptlCd,
                cnncPatntNo: item.cnncPatntNo
            }));



            //console.log("reqParam : " , reqParam)

            const reqOptions = {
                headers: {
                    Authorization: jToken,
                }
                , withCredentials: true
            }

            const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

            await axiosApi.post(url, reqParam, reqOptions)
            .then((res) => {
                //console.log(res.data.resultCode)
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    const mediInfo = res.data.result;


            //         console.log("userHospitalArr ::: ", userHospitalArr);


                    const usrHsptlMap = [
                        ...(loginUser.usrHsptlMap || []), // 기존 usrHsptlMap
                        ...(userHospitalArr || [])     // hsptlMap 데이터 추가
                    ]

                    const rtnHstplMap = usrHsptlMap.map((item, index) => ({
                        ...item,
                        hsptlSortOrdr: index+1,  // index 값을 순서로 넣기
                    }));

                    loginUser.usrHsptlMap = rtnHstplMap;

                    // console.log("--------------------loginUser.usrHsptlMap : ", loginUser.usrHsptlMap)
                    // console.log("--------------------JSON.stringify(loginUser) : ", JSON.stringify(loginUser))

                    sessionStorage.removeItem("loginUser");
                    // sessionStorage에 저장
                    sessionStorage.setItem("loginUser", JSON.stringify(loginUser));

                } else {
                    alert(res.data.resultMessage);
                }
            })
            .catch(err => {
                console.error("사용자의료건강정보 호출 중 오류  : ", err);
            })

        }

    }, []);


    const handleOnHospitalLink = async () => {


            const userHospitalArr = await searchPatientByHospital();

            if (userHospitalArr.length > 0) {
                //
                setStep("x");
            }

            if(Array.isArray(userHospitalArr)){
                await getClnicInfo(userHospitalArr);

                // if (userHospitalArr.length > 0) {
                // console.log("URL.q : ", URL.MY_HOSPITAL_CONNECTION)
                // console.log("-===================================");
                // console.log("userHospitalArr : ", userHospitalArr)
                navigate(URL.MY_HOSPITAL_CONNECTION, {
                    state: {
                        hsptlCd : hsptlCd,
                        hsptlConntion : userHospitalArr,
                        hsptlNext : "third"
                    },
                });

            }

    };

    /**
     * 환자번호 연동
     * @returns {boolean}
     */
    const searchPatientByHospital = async () => {

        // console.log ( " searchPatientByHospital userCertCheck : ", userCertRule );
        if(userNmRef.current.value.length < 1) {
            setToastMessage("이름을 입력해주세요");
            setToast(true);
            return false;
        }

        if(!firstPidRule.lengthAt) {
            setToastMessage("주민번호 앞자리 6자리를 정확히 입력해주세요.");
            setToast(true);
            return false;
        }
        if(!firstPidRule.birthAt) {
            setToastMessage("주민번호 생년월일 형식이 잘못되었습니다.");
            setToast(true);
            return false;
        }
        if(!lastPidRule) {
            setToastMessage("주민번호 뒷자리 7자리를 정확히 입력해주세요.");
            setToast(true);
            return false;
        }
        if(!agreeCheck) {
            setToastMessage("개인정보 활용 동의는 필수 입니다.");
            setToast(true);
            return false;
        }
        // 김하용, 가입정보와 입력정보 유효검사로.. 운영시 주석해제 필수임!!!
        if(!DEV_MODE_AT) { // 연구팀 테스트를 위해 ~ 운영인 경우만 체크하도록 조정..
            if (!userCertRule.nameCheck || !userCertRule.birthCheck || !userCertRule.genderCheck) {
                setToastMessage("가입한 정보와 상이합니다. 정확히 본인 정보를 입력해주세요.");
                setToast(true);
                return false;
            }
        }

        // reqHsptlList 구성
        const reqHsptlList = hsptlCd.map((cd, idx) => ({
            hospitalCd: cd,
            cnncHsptlNm: hsptlNm[idx] || ""
        }));

        const searchInfo = {
            patientNm: userNmRef.current.value,
            regidentNo: firstPidRef.current.value + lastPidRef.current.value,
            reqHsptlList
        };

        let objArr = [];
        let idx = 0;
        let errIdx = 0;

        await getNuPatientNumberByHospital(searchInfo)
            .then((res) => {
                const resData = res;

                if( resData.resultCode === CODE.RCV_SUCCESS ) {
                    const nuPatientList = resData.result.nuPatientList;
                    if( nuPatientList.length > 0 ) {
                        console.log( " ===============> searchNuPatientNumberByHospital : ", nuPatientList );
                        nuPatientList.forEach( (item) => {
                            console.log("*&************************ item ", item)
                            objArr.push({
                                usrInfoId: user.usrInfoId,
                                cnncHsptlCd: item.hospitalCd,
                                cnncHsptlNm: reqHsptlList.find(item => item.hospitalCd === item.hospitalCd)?.cnncHsptlNm || "",
                                cnncPatntNo: item.patientId,
                                hsptlSortOrdr: idx++
                            });
                        });
                    }
                } else {
                    //errIdx = 1;
                }
            })
            .catch((err) => {
                console.log(" ===============> getNuPatientNumberByHospital error : ", err);
                errIdx = 1;
            });


        console.log( " ===============>  메시지가 ... 나오나 ... ?? ");

        // for(let hospital of hospitalList) {
        //     //console.log(" handleOnSearchPatientByHospital HOSPITAL_GRP : ", item);
        //     searchInfo.hospitalCd = hospital?.insttClCd;
        //     if( searchInfo.hospitalCd ) {
        //         // 로딩 필요시 ... 동글뱅이...

        //         console.log("searchInfo.hospitalCd : '", searchInfo.hospitalCd)

        //         await getPatientNumberByHospital(searchInfo)
        //             .then((res) => {
        //                 const result = res?.root?.list?.result;
        //                 if (result) {
        //                     objArr.push({
        //                         usrInfoId: user.usrInfoId,
        //                         cnncHsptlCd: result.hospitalCd,
        //                         cnncHsptlNm: hospitalList.filter((data) => data.insttClCd === searchInfo.hospitalCd)[0].insttNm,
        //                         cnncPatntNo: result.patientId,
        //                         hsptlSortOrdr: idx++
        //                     });
        //                 }
        //             })
        //             .catch((err) => {
        //                 console.log(" ===============> getPatientNumberByHospital error : ", err);
        //                 errIdx++;
        //             });

        //     } else {
        //         errIdx++;
        //     }
        // }
        if(errIdx > 0) {
            // 에러는 이걸 타도록
            setAlertText("환자정보 조회가 실패하였습니다.\n입력한 정보를 확인하시고,\n다시 시도해 주세요.\n(* 현재 시범운영 중으로 서울, 은평, 인천, 부천성모병원만 조회 가능합니다)");
            setIsAlertOpen(true);
            //setToastMessage("환자정보 조회가 실패하였습니다.\n입력한 정보를 확인하시고, 다시 시도해 주세요.\n(현재 시범운영 중으로 서울,은평성모병원만 조회 가능합니다)");
            //setToast(true);
            return false;
        }

        if( objArr.length > 0 ) {

            let checkGrp = {};
            // 운영시 주석처리 필수..
            //objArr = samplePatientMappingData(objArr, idx, 2);

            let objIdx = 1;
            objArr.forEach( (item) => {
               if(objIdx === 1) {
                   checkGrp = { ...checkGrp, ["select" + objIdx]: true };
               } else {
                   checkGrp = { ...checkGrp, ["select" + objIdx]: false };
               }
               objIdx++;
            });

            setPatientCheck(checkGrp);
            //console.log( " =============> 등록된 병원조회수 : ", objArr.length );
            setHospitalMap(objArr);
            setUserNm(userNmRef.current.value); // 최종 셋팅한 이름.
        } else {
            // 맵핑 병원이 0인 경우,
            setToastMessage("환자정보가 존재하지 않습니다.\n입력한 정보를 확인하시고, 다시 시도해 주세요.\n(* 현재 시범운영 중으로 서울, 은평, 인천, 부천성모병원만 조회 가능합니다)");
            setToast(true);
            return false;
        }

        //console.log( " =======> handleOnSearchPatientByHospital end <================ ");

        return objArr;

    };

    /**
     * 병원맵핑 환자 샘플데이터 생성 ( 최대 4개까지만 허용, 기본 1개 ) ...
     *  개발 및 테스트 용이며 운영에선 사용되지 않음
     * @param object
     * @param idx
     * @param number
     */
    const samplePatientMappingData = (object, idx, number = 1) => {

        const samplePatient = [
            { cnncHsptlCd: "014", cnncHsptlNm: "부천성모병원(샘플)", cnncPatntNo: "10001402", hsptlSortOrdr: 2, usrInfoId: user.usrInfoId }
            , { cnncHsptlCd: "015", cnncHsptlNm: "은평성모병원(샘플)", cnncPatntNo: "10015002", hsptlSortOrdr: 3, usrInfoId: user.usrInfoId }
            , { cnncHsptlCd: "016", cnncHsptlNm: "인천성모병원(샘플)", cnncPatntNo: "10006002", hsptlSortOrdr: 4, usrInfoId: user.usrInfoId }
            , { cnncHsptlCd: "012", cnncHsptlNm: "서울성모병원(샘플)", cnncPatntNo: "40184412", hsptlSortOrdr: 5, usrInfoId: user.usrInfoId }
        ];
        object.push({ ...samplePatient[0], hsptlSortOrdr: idx++ });

        if( number > 1 && number < 4) {
            if(number === 2) {
                object.push({ ...samplePatient[1], hsptlSortOrdr: idx++ });

            }
            if(number === 3) {
                object.push({ ...samplePatient[1], hsptlSortOrdr: idx++ });
                object.push({ ...samplePatient[2], hsptlSortOrdr: idx++ });
            }
            if(number === 4) {
                object.push({ ...samplePatient[1], hsptlSortOrdr: idx++ });
                object.push({ ...samplePatient[2], hsptlSortOrdr: idx++ });
                object.push({ ...samplePatient[3], hsptlSortOrdr: idx++ });
            }
        }
        return object;
    };

    // number 길이 체크
    const lengthChk = (e)=>{
        if (e.target.value.length > e.target.maxLength)
            e.target.value = e.target.value.slice(0, e.target.maxLength);
    }

    const patientSettingByHospital = () => {

        const patientTag = [];

        let selectIdx = 1;
        hospitalMap.forEach( (item) => {

            patientTag.push(
                <li key={selectIdx}>
                    <div className="chkbox-custom" data-chkbox="chk-to-ridio">
                        <input type="checkbox" id={"select"+selectIdx} name={"select"+selectIdx}
                               checked={patientCheck["select"+selectIdx]}
                               onChange={handleOnChangeCheck}
                        />
                        <label htmlFor={"select" + selectIdx }>
                            <div className={style['txt-box']}>
                                <p>{ item.cnncHsptlNm }</p>
                                <span>{ item.cnncPatntNo }</span>
                            </div>
                        </label>
                    </div>
                </li>
            )
            selectIdx++;
        });

        return patientTag;
    };

    useEffect(() => {
        //약관 목록 호출
        const getData = async () => {

            const url = `/signup/retrieveHospitalPolicyIdList`;

            await axiosApi.post(url, ["D"])
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    const list = res.data.result.result;

                    let hospitalText =  hsptlNm.join(', '); // 선택병원 텍스트
                    let hospitalTextMain =  list[0].stplatPolicyCn.replaceAll("%^선택병원%", hospitalText);

                    setPoliceList(list); // 오리진데이터 저장

                    if (list.length > 0) {
                        setPoliceInfo({ // 표현데이터 ..
                            title: list[0].stplatPolicySj,
                            children: hospitalTextMain
                        });
                    }
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("searchHospitalPolicyId err  : ", err);
            })
        }
        getData();

    },[]);

    const handleClickPolicBtn = () => {

        if (policeInfo.title && policeInfo.children ) {
            setOpen(true);
        } else {
            setToastMessage("약관 정보를 불러올 수 없습니다.");
            setToast(true);
        }
    };


    return (
        <>
            <HeadSub title="병원 환자번호 연동" onBack={handleOnBack} />

            {/* 탈퇴버튼 (2025.05.22)*/}
            <div className={style['quit-btn-box']}>
                <button className={style['quit-btn']}
                        onClick={() =>
                            navigate(URL.MYINFO_WRITE, { state: {
                                    from: location.pathname, // 또는 location (search, state 포함)
                                }
                            })
                        }>
                    <span className="blind">탈퇴하기</span>
                </button>
            </div>

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">

                    {/* 이름 생년월일 확인 컴포넌트  */}
                     { step === 1 &&
                     <div className='animation-2'>
                        <div className={style['compotent-box']}>

                            <div className={style['content-box']}>
                                <strong className={style['title']}>
                                    환자번호 연동을 진행합니다. <br />
                                    이름과 생년월일을 확인해주세요.
                                </strong>

                                <div className={style['input-wrap']}>
                                    <span className={style['input-tit']}>주민번호</span>

                                    <div className={style['birth-input-box']}>
                                        <div className={style['input-box']}>
                                            <input type="number" name="firstPid"
                                                   placeholder="주민번호 앞자리"
                                                   maxLength={6}
                                                   ref={firstPidRef}
                                                   onInput={lengthChk}
                                                   onChange={handleOnChangeInput}
                                            />
                                            <span className={style['line']}
                                                  data-discord={
                                                    firstPidRef.current?.value && (!firstPidRule.lengthAt || !firstPidRule.birthAt)
                                                    ? 'on'
                                                    : undefined
                                                }></span>
                                        </div>

                                        <div className={style['input-box']}>
                                            <div className={style['pw-box']}>
                                                <input type={lastPidView ? 'text' : 'password'} name="lastPid"
                                                       placeholder="주민번호 뒷자리"
                                                       maxLength={7}
                                                       ref={lastPidRef}
                                                       onInput={lengthChk}
                                                       onChange={handleOnChangeInput}
                                                />
                                                <span className={style['line']}
                                                      data-discord={
                                                        lastPidRef.current?.value && !lastPidRule
                                                        ? 'on'
                                                        : undefined
                                                    }></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={style['input-wrap']}>
                                    <span className={style['input-tit']}>이름</span>
                                    <div className={style['input-box']}>
                                        <input type="text" name="userNm"
                                               ref={userNmRef}
                                               defaultValue={ user?.usrNm ? user?.usrNm : '' }
                                               placeholder="이름 입력"
                                               onChange={handleOnChangeInput}
                                               disabled={DEV_MODE_AT ? false : true}
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                </div>

                            </div>

                            <div className={style['agree-box']}>
                                <div className={style['top']}>
                                    <p>병원 연동을 위해 <br />
                                        개인정보 활용에 동의해 주세요</p>
                                </div>
                                <div className={style['botm']}>
                                    <div className='chkbox-custom' data-chkbox='basic'>
                                        <input type="checkbox" id='require-chk2' checked={agreeCheck} onChange={handleOnChangeCheck} />
                                        <label htmlFor="require-chk2">
                                            <div className={style['txt-box']}>
                                                <b>&#91;필수&#93;</b> <p>{policeInfo.title}</p>
                                            </div>
                                        </label>
                                    </div>

                                    <button className={style['more-btn']} onClick={() => handleClickPolicBtn()}>
                                        <span>보기</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                     </div>
                     }

                    {/* 병원 선택 컴포넌트 */}
                    { step > 1 &&
                    <div className='animation-2'>
                        <div className={style['compotent-box']}>

                            <div className={style['content-box']}>
                                <strong className={style['title']}>
                                아래 병원에서 <br />
                                    { userNm }
                                    님의 환자번호가 확인되었습니다

                                <p>대표 병원을 선택해 주세요</p>

                                </strong>
                            </div>

                            <div className={style['content-box']}>
                                <div className={style['selecting-box']}>
                                    <ul>
                                        { hospitalMap.length > 0 &&
                                            patientSettingByHospital()
                                        }
                                        {/* 디자인부 참조 샘플...
                                        <li>
                                            <div className='radio-selectbox' data-style="basic">
                                                <input type="radio" id="select1" name='hospital-select'/>
                                                <label htmlFor="select1">
                                                    <div className={style['txt-box']}>
                                                        <p>서울성모병원</p>
                                                        <span>10254384</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </li>

                                        <li>
                                            <div className='radio-selectbox' data-style="basic">
                                                <input type="radio" id="select2" name='hospital-select'/>
                                                <label htmlFor="select2">
                                                    <div className={style['txt-box']}>
                                                        <p>인천성모병원</p>
                                                        <span>15468523</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='radio-selectbox' data-style="basic">
                                                <input type="radio" id="select3" name='hospital-select'/>
                                                <label htmlFor="select3">
                                                    <div className={style['txt-box']}>
                                                        <p>대전성모병원</p>
                                                        <span>25798535</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </li>
                                        */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                        {/* 하단 다음 버튼 영역 :: S */}
                        <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className='btn-layout' data-btn-num="1">

                                    {/* <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={onSubmit}>
                                        <span>다음</span>
                                    </button> */}
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleOnHospitalLink}>
                                        <span>{ step === 1 ? '다음' : '연동하기' }</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                        {/* 하단 다음 버튼 영역 :: E */}



                        {/* // 로딩 관련
                        <div className={style['last-loading-box']}>
                            <div className='animation-3'>
                                <p>
                                    <b>{user.usrNm}</b>님의 의료 정보를 <br />
                                    보기 편하게 요약하고 있어요.
                                </p>
                                <strong>잠시만 기다려주세요!</strong>
                                <div className={style['img-box']}>
                                    <img src={imgLastLoading} alt="" />
                                </div>
                            </div>
                        </div>
                        */}

                        <BottomSheet

                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지

                            open={open}
                            onDismiss={onDismiss}
                            snapPoints={({ maxHeight }) => [
                                maxHeight - maxHeight / 10,
                                maxHeight * 0.6,
                              ]}
                            blocking={true}
                            className={style['header-top']}
                            >
                            <AgreeConditionsBox onClose={onDismiss} title={policeInfo.title} children={policeInfo.children}/>
                        </BottomSheet>


                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                        />
                    )}
                </div>
            <AlertBox
                isOpen={isAlertOpen}
                onClose={handleOnAlertClose}
                message={alertText}
                btnTxt='확인'
            />
        </>
    )
}

export default MyHospitalLink
